import React from 'react';
import { CircleBtn, PillBtn } from './GameButtons';
import { ACTION_BTNS, SCORING_BTNS } from './gameConstants';

const GRID = 'grid grid-cols-2 gap-3 md:gap-5 w-full max-w-[260px] md:max-w-[360px] lg:max-w-[420px]';

// Left column: made / miss scoring buttons.
export function ScoringColumn({ onStatTap }) {
  return (
    <div className="col-span-3 sm:col-span-3 flex flex-col items-center gap-3 py-2" data-testid="scoring-column">
      <div className={GRID}>
        {SCORING_BTNS.map(btn => (
          <div key={btn.key} className="flex justify-center">
            <CircleBtn tone={btn.tone} onClick={() => onStatTap(btn)} testId={`stat-${btn.key}`}>
              <span className="text-base sm:text-lg md:text-2xl lg:text-3xl font-extrabold">{btn.label}</span>
            </CircleBtn>
          </div>
        ))}
      </div>
    </div>
  );
}

// Right column: rebounds / turnovers / steals / assists / blocks + sub & foul.
export function ActionsColumn({ onStatTap, onSub, onFoul }) {
  return (
    <div className="col-span-3 sm:col-span-3 flex flex-col items-center gap-3 py-2" data-testid="actions-column">
      <div className={GRID}>
        {ACTION_BTNS.map(btn => (
          <div key={btn.key} className="flex justify-center">
            <CircleBtn tone="neutral" onClick={() => onStatTap(btn)} testId={`stat-${btn.key}`}>
              <span className="text-sm md:text-xl lg:text-2xl font-bold">{btn.label}</span>
              {btn.sub && <span className="text-[10px] md:text-xs font-normal opacity-80 -mt-0.5">{btn.sub}</span>}
            </CircleBtn>
          </div>
        ))}
      </div>
      <div className="flex gap-2 mt-2">
        <PillBtn tone="danger" onClick={onSub} testId="open-sub-btn">sub</PillBtn>
        <PillBtn tone="neutral" onClick={onFoul} testId="stat-foul">foul</PillBtn>
      </div>
    </div>
  );
}
